import { Component, computed, inject, input, InputSignal } from '@angular/core';
import { AufgabenTyp } from '@schir-int-client/aufgabe-shared';
import { CreateAufgabeFormService } from '@schir-int-client/aufgabe';
import { RegisterName } from '@schir-int-client/register-shared';

type AllowedAufgabenTyp = AufgabenTyp.MESSBRIEF | AufgabenTyp.VERMESSUNGSURKUNDE;

@Component({
	selector: 'schir-int-client-aufgabe-messbrief-editor',
	templateUrl: 'aufgabe-messbrief-editor.component.html',
	styleUrl: 'aufgabe-messbrief-editor.component.scss',
	standalone: false,
})
export class AufgabeMessbriefEditorComponent {
	private readonly formService = inject(CreateAufgabeFormService);

	readonly aufgabenTyp: InputSignal<AllowedAufgabenTyp> = input.required<AllowedAufgabenTyp>();
	readonly register: InputSignal<RegisterName> = input.required<RegisterName>();

	protected readonly isMessbrief = computed(() => this.aufgabenTyp() === AufgabenTyp.MESSBRIEF);
	protected readonly urkundenName = computed(() =>
		this.isMessbrief() ? 'Messbrief/Schiffszeugnis' : 'Vermessungsurkunde'
	);
	protected readonly isBSR = computed(() => this.register() === RegisterName.BSR);

	get formGroup() {
		return this.formService.form.controls[this.aufgabenTyp()];
	}

	get bodyControls() {
		return this.formGroup.controls.body.controls;
	}

	get originalAnControls() {
		return this.bodyControls.originalAn.controls;
	}

	get ergaenzenSendenControls() {
		return this.bodyControls.ergaenzenSenden.controls;
	}

	toggleOriginalAnGroup(enable: boolean) {
		enable ? this.bodyControls.originalAn.enable() : this.bodyControls.originalAn.disable();
	}

	toggleErgaenzenSendenGroup(enable: boolean) {
		enable ? this.bodyControls.ergaenzenSenden.enable() : this.bodyControls.ergaenzenSenden.disable();
	}
}
